import VueUeditorWrap from 'vue-ueditor-wrap'

export default {
    data() {
        return {
            textContent: '',
            editorConfig: {
                // 编辑器不自动被内容撑高
                autoHeightEnabled: false,
                // 初始容器高度
                initialFrameHeight: 240,
                // 初始容器宽度
                initialFrameWidth: '100%',
                // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
                // serverUrl: '/quoter/static/Ueditor/asp/config.json', //测试
                serverUrl: 'asp/config.json',
                // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
                // UEDITOR_HOME_URL: '/static/Ueditor/' //本地
                UEDITOR_HOME_URL: process.env.BASE_URL + 'static/Ueditor/' //生产
                // serverUrl: '/static/Ueditor/asp/config.json', //本地
            },
        }
    },
    components: {
        VueUeditorWrap
    },
    methods: {
        ueditorReady() {
          var ue = window.UE.getEditor("editor");
          console.log(ue);
          return ue;
        },
        beforeUEditorInit() {
          var ue = window.UE.getEditor("editor");
          UE.Editor.prototype._bkGetActionUrl = UE.Editor.prototype.getActionUrl;
          UE.Editor.prototype.getActionUrl = function(action) {
              console.log(action,"--->action")
            if (
              action == "uploadimage" ||
              action == "uploadscrawl" ||
              action == "uploadimage" ||
              action == "uploadvideo" ||
              action == "uploadfile"
            ) {
              return "/api_b/ueditor/fileUpload2";
            } else if (action == 'config') {
              return process.env.BASE_URL + 'static/Ueditor/asp/config.json'
            } else {
              return this._bkGetActionUrl.call(this, action);
            }
          };
          console.log("UE -> ", UE, ue);
        },
    }
}